import { getEmpresaContexto } from 'app/utils/geralUtil';
import axios from './financeiroApi';

const PATH = '/api/v1/backend/conciliacao';

const conciliacaoApi = {
  cadastrarContaPagar: (extratoId, contaPagar, permitirDuplicada) => {
    const _contaPagarConciliacao = {
      contaPagar: { ...contaPagar },
      id: extratoId,
      empresaId: getEmpresaContexto(),
    };
    const url = `${PATH}/conta-pagar?permitirDuplicada=${!!permitirDuplicada}`;
    return axios.post(`${url}`, _contaPagarConciliacao);
  },
  cadastrarContaReceber: (extratoId, contaReceber) => {
    const _contaReceberConciliacao = {
      contaReceber: { ...contaReceber },
      id: extratoId,
      empresaId: getEmpresaContexto(),
    };
    return axios.post(`${PATH}/conta-receber`, _contaReceberConciliacao);
  },
  editarContaReceber: (extratoId, contaReceber) => {
    const _contaReceberConciliacao = {
      id: extratoId,
      empresaId: getEmpresaContexto(),
      contaReceber: { ...contaReceber },
    };
    return axios.put(`${PATH}/conta-receber/${contaReceber.id}`, _contaReceberConciliacao);
  },
  editarContaPagar: (extratoId, contaPagar, permitirDuplicada) => {
    const _contaPagarConciliacao = {
      contaPagar: { ...contaPagar },
      id: extratoId,
      empresaId: getEmpresaContexto(),
    };
    const url = `${PATH}/conta-pagar/${contaPagar.id}?permitirDuplicada=${!!permitirDuplicada}`;
    return axios.put(`${url}`, _contaPagarConciliacao);
  },
  uploadArquivo: async (arquivo) => {
    return axios.put(`${PATH}/upload-lancamento`, arquivo, {
      headers: {
        'Content-Type': 'multipart/form-data',
        type: 'formData',
      },
    });
  },
  buscarLancamentos: async (filtros, search) => {
    return axios.get(`${PATH}/buscar-lancamentos`, { params: { ...filtros, ...search } });
  },
  buscarContaPagarFiltroTodos: async (filtros) => {
    return axios.get(`${PATH}/conta-pagar/buscar`, { params: filtros });
  },
  buscarContaReceberFiltroTodos: async (filtros) => {
    const getParams = (params) => {
      let newParams;
      if (params?.filtroAvancado) {
        newParams = { ...params, ...params.filtroAvancado };

        delete newParams.filtroAvancado;
      } else {
        newParams = params;
      }

      newParams = {
        ...newParams,
        mesCompetencia: newParams?.mesCompetencia?.format('YYYY-MM-DD'),
        dataVencimento: newParams?.dataVencimento?.format('YYYY-MM-DD'),
        dataRecebimento: newParams?.dataRecebimento?.format('YYYY-MM-DD'),
        dataVencimentoRecebimento: newParams?.dataVencimentoRecebimento?.format('YYYY-MM-DD'),
        categoriaId: newParams?.categoriaId || newParams?.categoria?.id,
      };

      return newParams;
    };

    return axios.get(`${PATH}/conta-receber/buscar`, { params: getParams(filtros) });
  },
  agrupar: async (request) => {
    return axios.post(`${PATH}/agrupar-selecionados`, request);
  },
  desagrupar: async (request) => {
    return axios.post(`${PATH}/desagrupar-selecionados`, request);
  },
  conciliar: async (request) => {
    return axios.post(PATH, request);
  },
  desconciliar: async (request) => {
    return axios.post(`${PATH}/desconciliar`, request);
  },
  acrescimosDescontos: async (request) => {
    return axios.post(`${PATH}/acrescimos-descontos`, request);
  },
};

export default conciliacaoApi;
